export default "__VITE_ASSET__e82a6003__"